module.exports = __webpack_public_path__ + "img/MB.74bd90ce.svg";